import { JSX } from 'react';
import { Box, CircularProgress } from '@mui/material';

export default function LoadingScreen(): JSX.Element {
  return (
    <Box
      data-testid="loading-screen"
      sx={{ display: 'flex', justifyContent: 'center', p: 4 }}
    >
      <CircularProgress />
    </Box>
  );
}
